var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreVisibility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 59,
    rx: 12,
    fill: "#FDE2E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.062 29.8474C19.9787 29.6229 19.9787 29.3759 20.062 29.1514C20.8737 27.1832 22.2515 25.5004 24.0208 24.3163C25.79 23.1321 27.8711 22.5 30 22.5C32.129 22.5 34.21 23.1321 35.9792 24.3163C37.7485 25.5004 39.1263 27.1832 39.938 29.1514C40.0214 29.3759 40.0214 29.6229 39.938 29.8474C39.1263 31.8155 37.7485 33.4983 35.9792 34.6825C34.21 35.8666 32.129 36.4988 30 36.4988C27.8711 36.4988 25.79 35.8666 24.0208 34.6825C22.2515 33.4983 20.8737 31.8155 20.062 29.8474Z",
    stroke: "url(#paint0_linear_830_10637)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 32.5C31.6569 32.5 33 31.1569 33 29.5C33 27.8431 31.6569 26.5 30 26.5C28.3431 26.5 27 27.8431 27 29.5C27 31.1569 28.3431 32.5 30 32.5Z",
    stroke: "url(#paint1_linear_830_10637)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_830_10637",
    x1: 19.9995,
    y1: 29.4994,
    x2: 40.0005,
    y2: 29.4994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_830_10637",
    x1: 27,
    y1: 29.5,
    x2: 33,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreVisibility);
export default __webpack_public_path__ + "static/media/Pre Visibility.ccc6881fa52ce82c9c7c4c576c20a81c.svg";
export { ForwardRef as ReactComponent };